import { Link } from "react-router-dom";
import "./LicensedPhotography.css";

export const responsivePhotographProps = (photo, sizes) => photo.license ? { srcSet: photo.srcSet, sizes, width: photo.width, height: photo.height } : {};

export const CompactPhotographCredit = ({ article, testId }) => article.hero.license ? <Link className="photograph-credit-compact" to={`${article.path}#article-hero-figure-credit`} data-testid={testId}>Photo credit</Link> : null;

export const PhotographCredit = ({ photo, testId }) => photo.license ? <span id={testId} tabIndex={-1} className="photograph-credit" data-testid={testId}>
  <a href={photo.source} target="_blank" rel="noreferrer" data-testid={`${testId}-source`}>{photo.title}</a>
  <span aria-hidden="true"> · </span>
  <a href={photo.authorUrl} target="_blank" rel="noreferrer" data-testid={`${testId}-photographer`}>{photo.credit}</a>
  <span aria-hidden="true"> · </span>
  <a href={photo.license.url} target="_blank" rel="license noreferrer" data-testid={`${testId}-licence`}>{photo.license.name}</a>
  <span data-testid={`${testId}-changes`}>{photo.changes}</span>
</span> : null;

export const LicensedPhotograph = ({ photo, testId, hero = false }) => <figure className={`licensed-photograph ${hero ? "article-hero-media shell" : "article-figure"}`} data-testid={testId}>
  <div className={hero ? "article-hero-image-frame" : "licensed-photo-frame"} data-testid={`${testId}-frame`}>
    <img src={photo.src} srcSet={photo.srcSet} sizes={photo.sizes} width={photo.width} height={photo.height}
      alt={photo.alt} loading={hero ? "eager" : "lazy"} fetchPriority={hero ? "high" : "auto"}
      style={{ objectFit: photo.fit, objectPosition: photo.position }} data-testid={hero ? "article-hero-image" : `${testId}-image`} />
  </div>
  <figcaption data-testid={`${testId}-caption`}>
    <span className="photograph-caption" data-testid={`${testId}-subject`}>{photo.caption}</span>
    <PhotographCredit photo={photo} testId={`${testId}-credit`} />
  </figcaption>
</figure>;